import {buildClientSchema} from "graphql";
import rootSchemaJson from "@graphql-schema";
import hpoSchemaJson from "@graphql-hpo-schema";
import dayjs from "dayjs";

export const schema = buildClientSchema(rootSchemaJson.data);
export const hpoSchema = buildClientSchema(hpoSchemaJson.data);

export const typesMap = {
    DateTime: {
        serialize: (parsed) => parsed.toISOString(),
        parseValue: (raw) => {
            return raw ? dayjs(raw) : null;
        }
    }
};
